export function buildAttributeByIdQueryV1(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Attributes.Queries.AttributeByIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'AttributeId': attributeId
	}
}

export function buildAttributesListByProjectIdQueryV1(workspaceId: number, projectId: number, includeSystemAttributes: boolean)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Attributes.Queries.AttributesListByProjectIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'IncludeSystemAttributes': includeSystemAttributes
	}
}

export function buildAttributeDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Attributes.Queries.AttributeDependenciesQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'AttributeId': attributeId,
	}
}

export function buildAttributeEditorQueryV1(workspaceId: number, projectId: number, attributeId: number | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Attributes.Queries.AttributeEditorQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AttributeId': attributeId,
	}
}

export function buildCalcAttributeScriptTestQueryV1(workspaceId: number, projectId: number, alternativesListId: number, script: string, inputs: { Name: string, Value: number }[])
{
	return {
		'$type': 'TCh.Domain.Alternatives.Attributes.Queries.CalcAttributeScriptTestQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'Script': script,
		'Inputs': inputs
	}
}

export function buildEmailAttributeDefinedValuesByPeopleTagQueryV1(workspaceId: number, projectId: number, peopleTag: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Attributes.Queries.EmailAttributeDefinedValuesByPeopleTagQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'PeopleTag': peopleTag,
	}
}

